<template>

    <div :style="{display:show?'block':'none'}" class="modal" style="z-index:12345;background:rgba(1,1,1,0.5);">
        <div style="position:relative;width:80%;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;text-align:center;">
            <div class="col-xs-12" style="margin-top:20px;margin-bottom:40px;">
                <slot></slot>
            </div>
            <div class="col-xs-12" style="position:absolute;bottom:10px;">
                <div class="col-xs-6"><span class="btn btn-default" @click="optionClicked(true)">{{lang.common.confirm}}</span></div>
                <div class="col-xs-6"><span class="btn btn-default" @click="optionClicked(false)">{{lang.common.cancel}}</span></div>
            </div>
        </div>
    </div>

    
</template>
<script>
    import modalX from './ModalX.vue';

    export default {
        components: {
            modalX: modalX,
        },
        props:["show"],
        data: function () {
            return {};
        },
        computed: {
            lang: function () {
                return this.$store.getters.lang;
            }
        },
        methods: {
            optionClicked: function (positive) {
                this.$emit("onselect", positive);
            }
        }
    }
</script>